document.addEventListener('DOMContentLoaded', function () {
 const hotspots = document.querySelectorAll('[data-hotspot-target]');

  var main = new Splide('#text__primary__slider', {
    type       : 'fade',
    rewind     : true,
    pagination : false,
    arrows     : true,
  });

  var thumbnails = new Splide('#tab__with_icon_slider', {
    gap         : 10,
    perPage     : 5,
    arrows      : false,
    rewind      : true,
    pagination  : false,
    cover       : true,
    isNavigation: true,
    breakpoints : {
      989: { perPage: 3 },
      749: { perPage: 2 },
    },
  });

  main.sync(thumbnails);

  thumbnails.mount();
  main.mount();

  /* =========================
     HOTSPOTS CONTROL THUMBNAILS
  ========================== */

  hotspots.forEach((btn, index) => {
    btn.addEventListener('click', function () {
      thumbnails.go(index); 
    });
  });

  /* =========================
     ADD ACTIVE CLASS TO HOTSPOTS
  ========================== */

  function updateHotspotActive(index) {
    hotspots.forEach(btn => btn.classList.remove('is-active'));
    if (hotspots[index]) {
      hotspots[index].classList.add('is-active');
    }
  }

  updateHotspotActive(0);

  main.on('moved', function (newIndex) {
    updateHotspotActive(newIndex);
  });

});